import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {mobileMediaQuery} from '../../../styles';

import swg from '../../../utils/smithwatermangotoh';

const SearchPreview = ({query, onPress}) => {
    const shows = useSelector(state => state.show.shows);
    const {t} = useTranslation();
    if (!shows) {
        return null;
    }

    let results = [];
    let maxScore = 0;
    shows.forEach(item => {
        let score = swg(item.title, query);
        if (score >= 0.5) {
            results.push({score, item});
            maxScore = Math.max(score, maxScore);
        }
    });
    results = results
        .filter(item => item.score > maxScore * 0.7)
        .sort((a, b) => b.score - a.score)
        .slice(0, 3);

    if (results.length === 0) {
        return null;
    }

    return (
        <Container>
            <Title>{t('search.didYouMean')}</Title>
            {results.map((item, index) => {
                return (
                    <>
                        <ResultText
                            key={String(item.item.id)}
                            onClick={() => onPress(item.item.title)}
                        >
                            {item.item.title.toUpperCase()}
                        </ResultText>
                        {index !== results.length - 1 && <Line />}
                    </>
                );
            })}
        </Container>
    );
};

const Container = styled.div`
    flex: 1;
    width: 100%;
    padding-horizontal: 25px;
    margin-top: 20px;
    max-width: 600px;
    align-self: center;
`;

const Title = styled.div`
    font-family: AvenirNextRoundedStd;
    font-weight: 700;
    font-size: 16px;
    color: white;
    align-self: center;
    margin-bottom: 20px;
    text-align: center;
    ${mobileMediaQuery} {
        text-align: left;
    }
`;

const ResultText = styled.div`
    font-family: TTNormsProExtraBlack;
    font-size: 20px;
    color: white;
    margin: 20px 0px;
    cursor: pointer;
`;

const Line = styled.div`
    height: 1px;
    background-color: white;
    opacity: 0.3;
`;

export default SearchPreview;
